var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleepDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_25973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 2C2.2 2.8 0 5.6 0 8.9C0 12.8 3.2 16 7.1 16C10.4 16 13.1 13.8 14 10.8C8.7 12.2 3.8 7.3 5.2 2Z",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2C10.5523 2 11 1.55228 11 1C11 0.447715 10.5523 0 10 0C9.44772 0 9 0.447715 9 1C9 1.55228 9.44772 2 10 2Z",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7C14 7.55228 14.4477 8 15 8Z",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z",
    fill: "#FFAB00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_25973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepDuration);
export default __webpack_public_path__ + "static/media/sleep-duration.753a3a97914c3accca9afb7a3f33ef07.svg";
export { ForwardRef as ReactComponent };